module.exports = __webpack_public_path__ + "img/319.e5282896.jpg";